import { render, staticRenderFns } from "./PersonalSubPage.vue?vue&type=template&id=1ca46c34&scoped=true&"
import script from "./PersonalSubPage.vue?vue&type=script&lang=ts&"
export * from "./PersonalSubPage.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalSubPage.vue?vue&type=style&index=0&id=1ca46c34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca46c34",
  null
  
)

export default component.exports